import { dataClient } from '../data/dataClient.js';

export function getCurrentSubscription(state = dataClient.peek()) {
  return state.subscriptionPlans.find(
    (plan) => plan.id === state.business.subscriptionPlanId
  );
}

// frontend.md §10: usage surfaces express consumption in Agent Operations,
// never dollars or token counts. Shared by Headquarters and Models.
export function getUsageSummary(state = dataClient.peek()) {
  const subscription = getCurrentSubscription(state);
  const allowance = subscription?.monthlyAoAllowance || 0;
  const used = state.business.aoUsedThisPeriod || 0;

  return {
    used,
    allowance,
    remaining: Math.max(0, allowance - used),
    planName: subscription?.displayName || 'Current plan'
  };
}

export function estimateAgenticOperations({ lead, consultedBots = [] }) {
  return 1 + (lead?.isLead ? consultedBots.length : 0);
}

export function assertAllowance(operations, state = dataClient.peek()) {
  const subscription = getCurrentSubscription(state);
  const allowance = subscription?.monthlyAoAllowance || 0;
  const used = state.business.aoUsedThisPeriod || 0;

  if (used + operations > allowance) {
    const error = new Error(
      `Plan limit reached. This request needs ${operations} Agent Operations, but only ${Math.max(0, allowance - used)} remain.`
    );
    error.code = 'AO_PLAN_LIMIT_REACHED';
    throw error;
  }

  return {
    allowed: true,
    allowance,
    used,
    remaining: allowance - used - operations
  };
}

export async function consumeOperations({
  operations,
  mode,
  botId,
  action
}) {
  const state = dataClient.peek();
  assertAllowance(operations, state);

  await dataClient.update('business', state.business.id, {
    aoUsedThisPeriod: (state.business.aoUsedThisPeriod || 0) + operations
  });

  return dataClient.create('usageLogs', {
    botId,
    operationsConsumed: operations,
    mode,
    action,
    timestamp: new Date().toISOString()
  });
}